///////////////////
// redux states  //
///////////////////
export interface StateRoot {
  appSettings: AppSettings; //mapping completed
  azure: AzureState; //mapping completed
  filterItems: FilterItemsState; //maoping completed
  salesInfo: SalesInfoState;
  changeRequest: ChangeRequestState; //unused state
  errors: ApplicationErrorState; //mapping completed
  router: any; //unused
  search: SearchState; //advanced search
}

export type IbUrl = {
  filter?: string;
  filterItem?: string;
  detail?: string;
  search?: string;
  page?: string;
};

export type UrlParams = {
  filter?: string;
  itemType?: string;
  parameter?: string;
  activeFilterParameter?: string;
  queryParams?: object;
};

export type QueryParam = {
  key: string;
  value: string;
};

export type Match = {
  params: UrlParams;
  isExact: boolean;
  path: string;
  url: string;
};

export type Location = {
  pathname: string;
  search: string;
  hash: string;
};

export type SalesInfoState = {
  search: string;
  isCountrySearch: boolean; //used in search
  showSearchClearer: boolean;
  editMode: boolean;
  previewMode: boolean;
  mobileMenuOpen: boolean;
  mobileSearchOpen: boolean;
  filesReadySendState: DocumentLinkUpload[];
  showMetaToFiles: string[];
  adminMenuActive: boolean; //check if the admin menu should be active or not
  filtersLoaded: boolean;
  selectedModalNavigationItem: DetailBaseData;
};

export type ApplicationErrorState = {
  errors: _.Dictionary<ApplicationError>;
};

export type AdvancedSearchProgress = {
  totalCount: number;
  resultCount: number;
};

export type SearchState = {
  results: any;
  filters: SearchFilters;
  options: SearchOptions;
  optionsLoaded: boolean;
  loading: boolean;
  searchIndex: string;
  tableColumns: SearchResultColumn[];
  tableSort: SearchSortRule;
  tableFilters: any[];
  groupBy: string;
  // recentQueries: UserSearch[];
  isEditMode: boolean;
  removedColumns: string[];
  isExporting: boolean;
  exportFileName: string;
  termsAndConditionsAccepted: boolean;
  exportFiles: { [id: string]: FileExport };
  downloadsMenuActive: boolean;
  exportColumns: ExportColumn[];
  latestAction: string;
  advancedSearchCancelled: boolean;
  advancedSearchProgress: AdvancedSearchProgress;
};

export enum FileExportStatus {
  Created = 0,
  Started = 1,
  Failed = 2,
  Succeeded = 3,
}
export type FileExport = {
  id: string;
  status: FileExportStatus | undefined;
  uri: string | undefined;
  visible: boolean;
};
export type FileExportActionPayload = {
  id: string;
  status: string | undefined;
  uri: string | undefined;
  message: string;
};

export interface SearchFilters {
  locationDescription: SearchFilterValue[];
  locationSiteId: SearchFilterValue[];
  marketAreas: SearchFilterValue[];
  countries: SearchFilterValue[];
  logicalFeatureTypes: SearchFilterValue[];
  salesforceLocationTypes: SearchFilterValue[];
  buildDescription: SearchFilterValue[];
  engineeringClasses: SearchFilterValue[];
  engineeringClassAttributeNames: SearchFilterValue[];
  proprietaryAttributeValues: SearchFilterValue[];
  installationDate: SearchFilterValue[];
  buildProjectId: SearchFilterValue[];
  buildId: SearchFilterValue[];
  buildSerialNumber: SearchFilterValue[];
  productGroupDescription: SearchFilterValue[];
  productFamilyDescription: SearchFilterValue[];
  productSeriesDescription: SearchFilterValue[];
  sellableProductModelDescription: SearchFilterValue[];
  productName: SearchFilterValue[];
  productDescription: SearchFilterValue[];
  productLifeCycleStates: SearchFilterValue[];
  productOriginalSource: SearchFilterValue[];
  productHierarchyCode: SearchFilterValue[];
  primaryCommodity: SearchFilterValue[];
  siteOperatingStatus: SearchFilterValue[];
  buildEndOfSupportDate: SearchFilterValue[];
  buildEndOfFullSupportDate: SearchFilterValue[];
  customerId: SearchFilterValue[];
  customerName: SearchFilterValue[];
  customerSalesAccountName: SearchFilterValue[];
  customerRole: SearchFilterValue[];
  customerCVCCategory: SearchFilterValue[];
  customerSiteAccountManager: SearchFilterValue[];
  locationNickname: SearchFilterValue[];
  buildLocationType: SearchFilterValue[];
  documentName: SearchFilterValue[];
  documentId: SearchFilterValue[];
  documentEffectiveDate: SearchFilterValue[];
  documentLocationSiteId: SearchFilterValue[];
  documentLocationType: SearchFilterValue[];
  documentLocationStatus: SearchFilterValue[];
  documentLocationSiteDescription: SearchFilterValue[];
  documentAuthor: SearchFilterValue[];
  documentDocTypeCode: SearchFilterValue[];
  documentIsDeliverable: SearchFilterValue[];
  documentFileName: SearchFilterValue[];
  buildOem: SearchFilterValue[];
  documentLocationInformationLifecycle: SearchFilterValue[];
  buildConstructionYear: SearchFilterValue[];
  buildDeliveryDate: SearchFilterValue[];
  buildGlobalProjectId: SearchFilterValue[];
  buildSource: SearchFilterValue[];
  buildTagNumber: SearchFilterValue[];
  buildWarrantyStartDate: SearchFilterValue[];
  locationDevelopmentState: SearchFilterValue[];
  buildApplication: SearchFilterValue[];
  buildCreatedDate: SearchFilterValue[];
  documentClassification: SearchFilterValue[];
  documentFunctionalLocationId: SearchFilterValue[];
  buildConfidentiality: SearchFilterValue[];
  LocationLatitudeLongitude: SearchFilterValue[];
  documentSource: SearchFilterValue[];
}

export interface SearchOptions {
  locationDescription: SearchSettingField;
  locationSiteId: SearchSettingField;
  marketAreas: SearchSettingField;
  countries: SearchSettingField;
  logicalFeatureTypes: SearchSettingField;
  salesforceLocationTypes: SearchSettingField;
  buildDescription: SearchSettingField;
  engineeringClasses: SearchSettingField;
  engineeringClassAttributeNames: SearchSettingField;
  proprietaryAttributeValues: SearchSettingField;
  installationDate: SearchSettingField;
  buildProjectId: SearchSettingField;
  buildId: SearchSettingField;
  buildSerialNumber: SearchSettingField;
  productGroupDescription: SearchSettingField;
  productFamilyDescription: SearchSettingField;
  productSeriesDescription: SearchSettingField;
  sellableProductModelDescription: SearchSettingField;
  productName: SearchSettingField;
  productDescription: SearchSettingField;
  productLifeCycleStates: SearchSettingField;
  productOriginalSource: SearchSettingField;
  productHierarchyCode: SearchSettingField;
  primaryCommodity: SearchSettingField;
  siteOperatingStatus: SearchSettingField;
  buildEndOfSupportDate: SearchSettingField;
  buildEndOfFullSupportDate: SearchSettingField;
  customerId: SearchSettingField;
  customerName: SearchSettingField;
  customerSalesAccountName: SearchSettingField;
  customerRole: SearchSettingField;
  customerCVCCategory: SearchSettingField;
  customerSiteAccountManager: SearchSettingField;
  locationNickname: SearchSettingField;
  buildLocationType: SearchSettingField;
  documentName: SearchSettingField;
  documentId: SearchSettingField;
  documentEffectiveDate: SearchSettingField;
  documentLocationSiteId: SearchSettingField;
  documentLocationType: SearchSettingField;
  documentLocationStatus: SearchSettingField;
  documentLocationSiteDescription: SearchSettingField;
  documentAuthor: SearchSettingField;
  documentDocTypeCode: SearchSettingField;
  documentIsDeliverable: SearchSettingField;
  documentFileName: SearchSettingField;
  buildOem: SearchSettingField;
  documentLocationInformationLifecycle: SearchSettingField;
  buildConstructionYear: SearchSettingField;
  buildDeliveryDate: SearchSettingField;
  buildGlobalProjectId: SearchSettingField;
  buildSource: SearchSettingField;
  buildTagNumber: SearchSettingField;
  buildWarrantyStartDate: SearchSettingField;
  locationDevelopmentState: SearchSettingField;
  buildApplication: SearchSettingField;
  buildCreatedDate: SearchSettingField;
  documentClassification: SearchSettingField;
  documentFunctionalLocationId: SearchSettingField;
  buildConfidentiality: SearchSettingField;
  LocationLatitudeLongitude: SearchSettingField;
  documentSource: SearchSettingField;
}

export interface SearchSettingField {
  descriptionSingular?: string;
  descriptionPlural?: string;
  searchIndexField?: string;
  options?: SearchFilterValue[];
  group?: SearchSettingGroupType;
  order?: number;
  elementType?: SearchSettingElementType;
  fieldType?: SearchSettingFieldType;
  valueType?: SearchSettingValueType;
  belongsToResultViews?: SearchSettingGroupType[];
  columnFieldInResultViews?: SearchSettingGroupType[];
  columnHeaderLabel?: string;
  parentField?: string;
  key?: string;
  isColumn?: boolean;
  placeholder?: string;
  hidden?: boolean;
  filterGroup?: SearchSettingGroupType;
  filterGroupOrder?: number;
  searchResultOrders?: SearchResultOrder[];
  searchable?: boolean;
}

export interface SearchResultOrder {
  view: SearchResultView;
  order: number;
  defaultColumn: boolean;
}

export enum SearchResultView {
  Builds = 1,
  Locations = 2,
  Customers = 3,
  Products = 4,
  Documents = 5,
}

export enum SearchSettingFieldType {
  Rule = 1,
  Filter = 2,
  RuleAndFilter = 3,
}

export enum SearchSettingGroupType {
  ClassAttribute = 0,
  Build = 1,
  Location = 2,
  Customer = 3,
  Product = 4,
  Document = 5,
}

export enum SearchSettingElementType {
  Text = 1,
  Select = 2,
  SelectFromOptions = 3,
  Checkbox = 4,
  Radio = 5,
  TextWithOperators = 6,
  SelectWithOperators = 7,
}

export enum SearchSettingValueType {
  String = 1,
  DateTime = 2, // Format: 2010-01-01T00:00:00Z
  Integer = 3,
  Double = 4,
  Boolean = 5,
  DateTimeComparison = 6,
}

export interface SearchSettingGroup {
  groupType: SearchSettingGroupType;
  settingFields: SearchSettingField[];
}

export interface SearchFilterValue {
  value: string;
  label?: string;
  type?: SearchSettingValueType;
  comparisonOperator?: string;
  compareTo?: string;
  compareFrom?: string;
  parentOption?: string;
  operator?: string;
  className?: string;
}

export interface SearchFilterPayload {
  filter: string;
  field: SearchFilterValue;
  elementType: SearchSettingElementType;
  operator?: string;
  singleValue?: boolean;
  label: string;
  isComparable?: boolean;
}

export interface MultipleSearchFilterPayload {
  elementType: SearchSettingElementType;
  filter: string;
  fields: SearchFilterValue[];
}

export interface AdvancedSearchApiPayload {
  searchIndex: string;
  filters: SearchFilter[];
  searchRules: SearchRule[];
  showLoading: boolean;
  columns: SearchResultColumn[];
  groupBy?: string;
  sort?: SearchSortRule;
  removedColumns: string[];
  exportColumns: ExportColumn[];
  skip: number;
  top: number;
  adminMarketArea?: string;
}

export interface UserProfile {
  savedSearchQueries: UserSearch[];
  hiddenFilters: string[];
}

export interface UserSearch {
  id?: string;
  date: string;
  searchIndex: string;
  filters: SearchFilters;
  displayName: string;
  activeColumns?: SearchResultColumn[];
}

export interface SearchSortRule {
  searchField: string;
  desc: boolean;
}

export interface ReactTableSort {
  label: string;
  desc: boolean;
}

export interface ReactTableFilter {
  label: string;
  value: string;
}

export interface ReactTableColumn {
  label: string;
  value: string;
}

export interface ReactSelectOption {
  label: string;
  value: string;
}

export interface SearchRule {
  operator: string;
  field: SearchSettingField;
  fieldValues: string[];
  classAttributeSearchIndexField?: string;
  comparisonOperator?: string;
}

export interface SearchFilter {
  operator: string;
  field: SearchSettingField;
  fieldValue: string;
  comparisonOperator: string;
  compareTo?: string;
  compareFrom?: string;
}

export interface BuildSearchResult {
  id: string;
  internalId: string;
  buildName: string;
  buildDescription: string;
  type: string;
  locationType: string;
  locationDescription: string;
  customerDescription: string;
  customerRole: string;
  installationDate: string;
  buildSerialNumber: string;
  buildProjectId: string;
  buildEngineeringClasses: string;
  buildProprietaryType: string;
  productLine: string;
  modelRevisionDescription: string;
  productLifecycleState: string;
  buildState: string;
  url: string;
  country: string;
  buildApplication: string;
  buildConfidentiality: string;
}

export interface CustomerSearchResult {
  id: string;
  internalId: string;
  description: string;
  type: string;
  siteId: string;
  siteName: string;
  siteDescription: string;
  siteCountry: string;
  role: string;
  countries: string[];
  url: string;
}

// export interface ProductSearchResult {
//     id: string
//     type: string
//     productDisplayName: string
//     productDisplayDescription: string
//     productDisplayType: string
//     productLineType: string
//     productLineDescription: string
//     productGroupDescription: string
//     productDescription: string
//     modelDescription: string
//     productLifecycleState: string
//     url: string
// }

export type AzureState = {
  uploadingDocuments: boolean; //state to know whether a document is uploading, can be taken as local state
  removingDocuments: boolean; //same as above
  requests: AzureRequest[]; // to load spinners while API call is happening, can be replaced with react query
  connectionIssue: boolean; //unused state
};

export type FilterItemsState = {
  allFilterItemIds: Array<string>;
  sitesFilterItemIds: Array<string>;
  customersFilterItemIds: Array<string>;
  productsFilterItemIds: Array<string>;
  searchItemIds: Array<string>;
  countryIds: Array<string>;
  productTypeIds: Array<string>;
  filterItemsById: any;
  quickSearchResults: any; //not used anywhere
  documentLinks: DocumentLink[]; // can be replaced with react query
  documentAttributeGroups: AttributeGroup[]; //can be replaced with react query
  projectAssetAttributeGroups: AttributeGroup[]; //can be replaced with react query
};

export type ChangeRequestState = {
  //unused state
  editedItemFields: EditableItemField[];
  editedSpareParts: EditableSparePart;
  addedSpareParts: SparePartChange[];
  removedSpareParts: SparePartChange[];
  newLevels: HierarchyLevel[];
  files: JiraFile[];
  availableSpareParts: ItemsApiSparePart[];
  sparePartDocuments: boolean;
  isDirty: boolean;
};

export type AzureRequest = {
  url: string;
  started?: Date;
  critical?: boolean;
};

export type HierarchyLevel = {
  id: string;
  parentId: string;
  parentType: string;
  description: string;
  info: string;
  operationStatus: string;
  lifeCycleState: string;
  type: string;
  children?: HierarchyLevel[];
  new: boolean;
};

export type EditableItemField = {
  inEditMode: boolean;
  siteId: string;
  objectId: string;
  dataGroupName: string;
  itemGroupName: string;
  fieldId: string;
  fieldType: EditableFieldType;
  fieldOldValue: string;
  fieldNewValue: string;
  required: boolean;
};

export enum EditableFieldType {
  Text = 1,
  Date = 2,
  PreDefinedValue = 3,
}

export interface SparePartChange extends ItemsApiSparePart {
  reasonForChange: string;
}

export interface EditableSparePart {
  [key: string]: EditableItemField[];
}

export type ChangeRequest = {
  status: string;
  assetId?: string;
  assetName?: string;
  siteId?: string;
  siteName?: string;
  siteDescription?: string;
  createdBy: string;
  type: string;
  fields: string;
  attributes?: any;
  notes?: string;
  createdDate: Date;
  externalId: string;
};

export interface RequestChangePayload {
  newTickets: RequestChangeTicket[];
  user: RequestChangeUserData;
  id: string;
  containsSparePartDocuments: boolean;
}

export interface RequestChangeUserData {
  name: string;
  isAdmin: boolean;
  email: string;
}

export interface RequestChangeTicket {
  target: {
    path: string;
    type: string;
    portalId: string;
    id: string;
    siteName: string;
  };
  newLevels: HierarchyLevel[];
  additionalInformation: string;
  changes: RequestChangeTicketField[];
  sparePartsChanged: RequestChangeSparePartsChanged;
  sparePartsAdded: PortalApiSparePart[];
  sparePartsRemoved: PortalApiSparePart[];
  files: JiraFile[];
}

export interface RequestChangeSparePartsChanged {
  [key: string]: RequestChangeTicketFieldChange[];
}

export interface RequestChangeTicketField {
  itemGroup: string;
  dataGroup: string;
  attributes: RequestChangeTicketFieldChange[];
}

export interface RequestChangeTicketFieldChange {
  name: string;
  oldValue: string;
  newValue: string;
}

export interface ServiceVisitReportFileType {
  label: string;
  value: string;
  key?: string;
}

export interface AppSettings {
  //getsetting API call set the whole state in this list
  //{
  //     "yammerFeedback": "https://www.yammer.com/metso.com/#/threads/inGroup?type=in_group&feedId=33368940544&view=all",
  //     "appInsightsInstrumentationKey": "9e9e36eb-baa8-4f62-b6ec-7a667512162e",
  //     "powerBiSettings": {
  //         "countryEmbedReportId": "aa87ced3-3afe-471f-a6e7-0bbb6bfa37fa",
  //         "sitesEmbedReportId": "aa87ced3-3afe-471f-a6e7-0bbb6bfa37fa"
  //     },
  //     "environment": "Development",
  //     "crmCustomerUrl": null,
  //     "crmOpportunityUrl": null,
  //     "crmSiteUrl": null,
  //     "serviceVisitReportFileTypes": [
  //         {
  //             "key": "Site Visit Report (Field Service)",
  //             "value": "SiteVisitReportFieldService"
  //         },
  //         {
  //             "key": "Site Visit Report (Technology Support)",
  //             "value": "SiteVisitReportTechnologySupport"
  //         },
  //         {
  //             "key": "Site Assessment / Audit (Technical)",
  //             "value": "SiteAssessmentAuditTechnical"
  //         },
  //         {
  //             "key": "Site Assessment / Audit (Process)",
  //             "value": "SiteAssessmentAuditProcess"
  //         },
  //         {
  //             "key": "Plant Performance Assessment",
  //             "value": "PlantPerformanceAssessment"
  //         },
  //         {
  //             "key": "Inspection Report",
  //             "value": "InspectionReport"
  //         },
  //         {
  //             "key": "Asset Walk Report",
  //             "value": "AssetWalkReport"
  //         },
  //         {
  //             "key": "IOMS manual",
  //             "value": "IOMSManual"
  //         },
  //         {
  //             "key": "Spare part list",
  //             "value": "SparePartList"
  //         },
  //         {
  //             "key": "Handover to MA checklist",
  //             "value": "HandoverToMAChecklist"
  //         },
  //         {
  //             "key": "GA drawing/P&ID",
  //             "value": "GADrawing/P&ID"
  //         },
  //         {
  //             "key": "Installation & Commissioning report",
  //             "value": "InstallationCommissioningReport"
  //         },
  //         {
  //             "key": "Technical Document",
  //             "value": "TechnicalDocument"
  //         }
  //     ],
  //     "feedbackUrlForBugReports": "https://forms.office.com/Pages/ResponsePage.aspx?Host=Teams&lang=%7Blocale%7D&groupId=%7BgroupId%7D&tid=%7Btid%7D&teamsTheme=%7Btheme%7D&upn=%7Bupn%7D&id=9FZUXALExUCnPeeHd-e_nsZT07panrFKlIBaogPX_TtUM1VKS0YxWTFQVUI1VVpXS1hERVZOVjlVMiQlQCN0PWcu",
  //     "feedbackUrlForFeatureRequests": "https://forms.office.com/Pages/ResponsePage.aspx?Host=Teams&lang=%7Blocale%7D&groupId=%7BgroupId%7D&tid=%7Btid%7D&teamsTheme=%7Btheme%7D&upn=%7Bupn%7D&id=9FZUXALExUCnPeeHd-e_nsZT07panrFKlIBaogPX_TtUQkFBTFgwQk5OTEExTlVBUlc5S0FaQkNVMSQlQCN0PWcu",
  //     "feedbackUrlForGeneralFeedback": "https://forms.office.com/Pages/ResponsePage.aspx?Host=Teams&lang=%7Blocale%7D&groupId=%7BgroupId%7D&tid=%7Btid%7D&teamsTheme=%7Btheme%7D&upn=%7Bupn%7D&id=9FZUXALExUCnPeeHd-e_nsZT07panrFKlIBaogPX_TtUM1BQWjNPMTZEWlVJS0ZSQkdNWjkzVDlRVyQlQCN0PWcu"
  // }
  // {
  //     "userName": "saibunneesa.s@metso.com",
  //     "marketAreas": [
  //         "Placeholder Markets",
  //         "Africa",
  //         "Asia-Pacific",
  //         "Europe and Central Asia",
  //         "Greater China",
  //         "Middle East & India",
  //         "North & Central America",
  //         "Central Asia",
  //         "South America",
  //         "Other Markets"
  //     ],
  //     "isAdminUser": true,
  //     "isBasicUser": false
  // }
  yammerFeedback: string; // uses the yammerfeedbackURl in the yammer button,present in api output
  attributeMap: AttributeMetadata[]; //used in EditableItemGroup,EditableSparePartItemGroup components which are used for displaying equipment and spare parts data.not present in api output
  appInsightsInstrumentationKey: string; //present in API output,diffrent for 3 environments,can be stored in front-end in webpack.env files
  powerBiSettings: PowerBiSettings; //present in API output, same for all environment
  siteStructureFileTemplateUrl: string; //not present in API output, not used anywhere
  sparePartFileTemplateUrl: string; //not present in API output, not used anywhere
  appSettingsLoaded: boolean; //not present in API, rather it marks if the settings API is loaded or not
  user: User; //not loaded in settings API, rather user/settings API is used
  activeMarketArea: string; //not loaded in settings API, rather user/settings API is used
  userMode: boolean; //not loaded in settings API, rather user/settings API is used, both this and above states are duplicated
  environment: string; //present in APi output, should be available from node process itself , no need of api call
  serviceVisitReportFileTypes: ServiceVisitReportFileType[]; //present in API output, used as document options while uploading files, seems like constant. need to verify in backend
  powerBiEmbedReport: PowerBiReportPayload; //not present in API output,unused state not needed
  feedbackUrlForBugReports: string; //below 3 fields are present in API output, need to check if they are constant, used for 3 buttons
  feedbackUrlForFeatureRequests: string;
  feedbackUrlForGeneralFeedback: string;
}

export type User = {
  // made a copy in new file
  userName: string;
  isAdminUser: boolean;
  marketAreas: string[];
};

export interface MarketAreaSettings {
  //same state present in the appsettings state as well, used in marketarea switcher
  activeMarketArea: string;
  userMode: boolean;
}

export interface PowerBiSettings {
  countryEmbedReportId: string;
  sitesEmbedReportId: string;
}

/////////////////////////////
// Detailsview & TreeView  //
/////////////////////////////
export interface DetailBaseData {
  hasChildren: boolean;
  url: string;
  name: string;
  description: string;
  parent?: string;
  showChildren?: boolean;
  id?: string;
  internalId?: string;
  type: string;
  isDetailView?: boolean;
  country?: string;
  active?: boolean;
  state?: string;
  source?: string;
  locationId?: string;
}

export interface DetailBaseDataCollection {
  type: string; // For which filter items belongs to
  items: DetailBaseData[];
}

export interface Detail extends DetailBaseData {
  header: DetailsHeader;
  dataGroups: DataGroup[];
  linkGroups?: LinkCard[];
  childItems: DetailBaseData[];
  state?: string;
}

export interface SiteDetail extends Detail {
  country: string;
  siteName: string;
  marketArea: string;
}

export interface ProductDetail extends Detail {
  productName: string;
  siteName?: string;
}

export interface CustomerDetail extends Detail {
  opportunities: Opportunity[];
  locations: LinkCollection;
  reports: LinkCollection;
  salesOrderUris: LinkCollection;
  siteName?: string;
}

// Short presentation way
export type DetailView = SiteDetail | ProductDetail | CustomerDetail;

export interface DataGridContent {
  columns: any[];
  data: any[];
}

export interface ExcelComment {
  author: string;
  comment: string;
}

export interface DetailCollection {
  type: string;
  sites: DetailView[];
  locations?: DetailView[];
  products: DetailView[];
  customers: DetailView[];
  builds?: DetailView[];
  documents?: DetailView[];
  totalCount?: number;
}

export interface SearchResults extends DetailCollection {
  isCountrySearch: string;
}

export interface DetailParents extends DetailCollection {
  rootElement: DetailBaseDataCollection;
}

export interface Opportunity {
  id: string;
  name: string;
  opportunityId: string;
}

// Determine if item sibligs should be open or clonse
export interface SiblingsState {
  node: DetailBaseData;
  open: boolean;
}

export interface SetOpenState {
  parents: string[];
  newState: boolean;
}

export type BaseDatas = {
  id: string;
  name: string;
  description: string;
  country: string;
  Type: string;
  modified: string;
  "modified by": string;
  longitude: string;
  latitude: string;
};

export type DataGroup = {
  dataGroupType: number;
  name: string;
  attributeGroups: AttributeGroup[];
};

export type AttributeGroup = {
  siteId?: string;
  name: string;
  rows: AttributeRow[];
  headers: string[];
  filterableColumns?: string[];
};

export type AttributeRow = {
  items: AttributeCell[];
  statusType?: AttributeGroupItemRowStatusType;
  isSummaryRow?: boolean;
  tab?: string;
  group?: string;
};

export type GroupedAttributeRow = AttributeRow & {
  children?: GroupedAttributeRow[];
  pending?: boolean;
};

export enum AttributeGroupItemRowStatusType {
  Obsolete,
  Active,
}

export type AttributeCell = {
  url: Link;
  description: string;
  toolTip?: string;
  additionalInfo?: string;
  isSummaryCell?: boolean;
};

/* Single link item in ui. */
export type Link = {
  id: string;
  type: string;
  description: string;
  url: string;
  additionalInfo?: string;
  openToNewTab?: boolean;
};

/* Single link item to file attached into site.  */
export interface DocumentLink {
  fileName: string;
  type: string;
  url: string;
  metaData: DocumentMeta;
  reasonForDelete: string;
  pending: boolean;
}

export interface DocumentMeta {
  hostId: string;
  documentType: string;
  created: string;
  createdBy: string;
  functionalLocation: string;
  siteName: string;
  documentId: string;
  workOrder: string;
}

export interface DocumentLinkUpload extends DocumentLink {
  filetype: string;
  file: File;
  target: string;
}

/* All links inside one card. */
export type LinkCollection = {
  description: string;
  urls: Link[];
  documentUrls: DocumentLink[];
};

/* All links to files inside one documents card. */
export type DocumentsLinkCollection = {
  description: string;
  urls: DocumentLink[];
};

/* Cards that shows only links */
export type LinkCard = {
  linkGroupType: number;
  name: string;
  links: LinkCollection[];
};

export type DetailLinkItem = {
  name: string;
  urlItems: Link[];
};

export type DetailLink = {
  customers: DetailLinkItem;
  products: DetailLinkItem;
  services: DetailLinkItem;
  salesOrders: DetailLinkItem;
};

// export interface ILinkNav {
//   links: DetailLinkItem;
//   jumpToDetails(
//     treetype: string,
//     requri: string,
//     viewId: string
//   ): Dispatch<any>;
// }

export type DetailsHeader = {
  key: string;
  value: string;
};

export enum ErrorTypes {
  External,
  Internal,
}

export interface ApplicationError {
  type: ErrorTypes;
  id: string;
  data?: string;
  status?: Number;
  statusText?: string;
  title?: string;
  message: string;
  error?: any; // if exception thrown
}

export interface AttributeMetadata {
  group: string;
  attribute: string;
  type: string;
  required: boolean;
  options: string[];
  default: any;
  maxLenght: Number;
  infoText: string;
}

export interface ItemsApiSparePartResponse {
  itemId: string;
  itemNumber: string;
  name: string;
  description: string;
  technicalDescription: string;
  isSparePart: boolean;
}

export interface ItemsApiSparePart {
  itemId: string;
  itemNumber: string;
  name: string;
  description: string;
  technicalDescription: string;
  isSparePart: string;
}

export interface PortalApiSparePart {
  itemId: string;
  itemNumber: string;
  name: string;
  description: string;
  isSparePart: boolean;
}

export interface SparePart {
  itemNumber: string;
  description: string;
  technicalDescription: string;
  isSparePart: string;
}

///////////////
// Selectors //
///////////////
export interface ActiveDetail {
  detail: DetailView;
  isProductDetail: boolean;
  isSiteDetail: boolean;
  isLinks: boolean;
  isCustomer: boolean;
  documentType: string;
}

/*
    Props
*/
export interface ILayoutProps {
  yammerFeedbackUri: string;
  errors: _.Dictionary<ApplicationError>;
  mobileMenuOpen: boolean;
  mobileSearchOpen: boolean;
  connectionIssue: boolean;
  isSettingsLoaded: boolean;
  history: any;
  location: Location;
  url: IbUrl;
  user: User;
  adminChangeRequestPageActive: boolean;

  // removeError(id: string): Dispatch<void>;
  // removeAppError(id: string): Dispatch<void>;
  // removeAllErrors(): Dispatch<void>;
  // getAppSettings(): Dispatch<void>;
  // onToggleMobileMenu(): Dispatch<void>;
  // onToggleMobileSearch(): Dispatch<void>;
  // removeConnectionIssueNotification(): Dispatch<void>;
  // initApp(url: IbUrl): Dispatch<void>;
  // clearSearchOnNavigate(): Dispatch<void>;
}

// export type LinkItemProps = {
//   list: Link[];
//   selectLink(e: any, item: Link): Dispatch<any>;
// };

export type DetailOtherProps = {
  others: {
    key: string;
    value: any;
  };
};

export type DetailOtherItemProps = {
  item: {
    key: string;
    value: string;
  };
};
// unused props types
//used for AdditionalInformationCard components
// export interface IAdditionalInformationCardProps {
//   changedEditableFields: EditableItemField[];
//   changedSpareParts: EditableSparePart;
//   addedSpareParts: SparePartChange[];
//   removedSpareParts: SparePartChange[];
//   canSend: boolean;
//   routedFromEditMode: boolean;
//   editableField: EditableItemField;
//   hierarchy: DetailBaseData[];
//   uploadedFiles: JiraFile[];
//   siteStructureFileTemplateUrl: string; //also present in settings Appsetting state
//   sparePartFileTemplateUrl: string; //also present in Appsettings

//   onChangeFieldValue: (editableField: EditableItemField) => Dispatch<any>;
//   onSubmitChangeRequest: () => Dispatch<any>;
// }

export interface LinksBaseProps {
  selectLink?: (e: any, link: Link) => void;
}

export interface LinkCardsProps extends LinksBaseProps {
  cards: LinkCard[];
  id: string;
  documentType: string;
  match: Match;
}

export interface LinkCardContentProps extends LinksBaseProps {
  links: LinkCollection[];
}

export interface DocumentsCardFileMetaProps {
  document: DocumentLink;

  handleFileRemove(document: DocumentLink): Function;
}

export interface LinkItemsProps extends LinksBaseProps {
  links: Link[];
}

export interface DocumentsCardLinkItemsProps extends LinksBaseProps {
  links: DocumentLink[];
  showMetaToFiles: string[];
  user: User;
  pendingFileChangeRequests: ChangeRequest[];

  onLinkClick(document: DocumentLink): Function;
  handleFileRemove(document: DocumentLink): Function;
  toggleFileMeta(filePath: string): Function;
}

export interface DocumentCardLinkItemsMetaBoxProps
  extends DocumentsCardFileMetaProps {
  user: User;
  marketAreaInfo: MarketAreaSettings;

  onNavigate(filePath: string): Function;
}

export interface HeaderProps {
  yammerUri: string;
}

export interface IHierarchyListProps {
  fromFilterItems: boolean;
  hierarchy: HierarchyLevel[];
  editable: boolean;
  match: Match;

  onAddNewLevel: (level: HierarchyLevel) => any;
  onUpdateNewLevel: (level: HierarchyLevel) => any;
  onDeleteNewLevel: (level: HierarchyLevel) => any;
}

export type EditableItemGroupProps = {
  attributeGroup: AttributeGroup;
  dataGroupName: string;
  isCustomerDetail: boolean;
  isInstalledBaseSection: boolean;
  isEditable: boolean;
  editedItemFields: EditableItemField[];
  attributeMap: AttributeMetadata[];
  changeRequests: ChangeRequest[];
  match: Match;
  selectedModalNavigationItem?: DetailBaseData;

  onChangeFieldValue: (editableField: EditableItemField) => void;
  onClearSelectedModalNavigationItem?: () => void;
  isConfigurationTab?: boolean;
};

export type EditableSparePartItemGroupProps = EditableItemGroupProps & {
  partNumber: string;
};

/*
    Misc
*/
export interface JiraFilesResponse {
  jiraFiles: JiraFile[];
}

export type JiraFile = {
  fileName: string;
  fileId: string;
};

export type SasFile = {
  file: string;
  sas: string;
};

export type BreadcrumbItem = {
  description: string;
  Url: string;
};

export interface ISearchSuggestionResponse {
  type: string;
  suggestions: string[];
}

export interface ISearchSuggestionSection {
  type: string;
  suggestions: ISearchSuggestion[];
}

export interface ISearchSuggestion {
  value: string;
}

export type SearchResultColumn = {
  searchField: string;
  displayName: string;
  active: boolean;
  columnFieldInResultViews: SearchSettingGroupType[];
  isColumn: boolean;
  filterable: boolean;
  classAttribute: boolean;
  order?: number;
  group?: SearchSettingGroupType;
  filterGroupOrder?: number;
  searchResultOrders?: SearchResultOrder[];
  Header?: string;
};

export type ExportColumn = {
  searchField: string;
  displayName: string;
  order: number;
};

export interface ISeachResultState {
  showColumns: boolean;
}

export interface SearchResultColumns {
  builds: SearchResultColumn[];
  locations: SearchResultColumn[];
  customers: SearchResultColumn[];
  products: SearchResultColumn[];
}

export interface PowerBiReportPayload {
  id: string;
  name: string;
  webUrl: string;
  embedUrl: string;
  accessToken: string;
}

export interface ComparisonOperatorField {
  key: string;
  value: string;
  fieldTypes: SearchSettingValueType[];
  elementTypes: SearchSettingElementType[];
  classAttribute: boolean;
}

export type BuildClassAttributeValue = {
  uom: string;
  value: string;
};

export type customerRoleEntry = {
  customerId?: string;
  customerName?: string;
  customerSalesAccountName?: string;
  customerRole?: string;
  customerCVCCategory?: string;
  customerSiteAccountManager?: string;
};

export type NewAssetRequest = {
  siteId: string;
  productId: string;
  globalProjectId: string;
  name: string;
  serialNumber: string;
  operatingStatus: string;
  startUpDate: string;
  equipmentType: string;
  deliveryProjectId: string;
  customerTagNumber: string;
  notes: string;
};

export type DeleteAssetRequest = {
  reason: string;
  notes: string;
};

export type PendingChangeRequest = {
  type: string;
  attributes: ChangeRequestAttribute[];
  notes: string;
  createdDate: Date;
  externalId: string;
};

export type ChangeRequestAttribute = {
  name: string;
  newValue: string;
  oldValue?: string;
};

export type EditAssetRequest = {
  attributes: Array<EditAssetRequestAttribute>;
  notes: string;
};

export type EditAssetRequestAttribute = {
  name: string;
  oldValue: string;
  newValue: string;
};
export type UnlinkAsset = {
  projectId: string;
  assetId: string;
};

export type AssetBasicDataModel = {
  source: string;
  locationName: string;
  description: string;
  serialNumber: string;
  productType: string;
  operatingStatus: string;
  deliveryDate: string;
  startupDate: string;
  manufacturer: any;
  ownershipStatus: string;
  equipmentCategory: string;
  warrantyStartDate: string;
  warrantyEndDate: string;
  extendedWarrantyStartDate: string;
  extendedWarrantyEndDate: string;
  extendedWarrantyType: string;
};

export type PagedQuerySortBy = {
  field: string;
  desc: boolean;
};

export type PagedQueryFilter = {
  field: string;
  value: string;
};

export type PagedQuery = {
  filters: PagedQueryFilter[];
  sort: PagedQuerySortBy;
  page: number;
  pageSize: number;
};

export type PagedQueryResponse = {
  rows: PagedQueryResponseRow[];
  totalCount: number;
};

export type PagedQueryResponseRow = {
  items: PagedQueryResponseRowItem[];
};

export type PagedQueryResponseRowItem = {
  description: string;
  id?: string;
  type?: string;
};

export type SellableProductModelDto = {
  name: string;
  description: string;
  id: string;
};

export type ModelRevisionDto = {
  name: string;
  description: string;
  id: string;
};

export type SerialNumberDto = {
  id: number;
  alternateId: string;
  name: string;
  serialNumber: string;
  productName: string;
  productTypeDescription: string;
  dbCreated: Date;
  dbModified: Date;
};

export type NotLinkedAssets = {
  alternateId: string;
  assetDescription: string;
  id: number;
  name: string;
  serialNumber: string;
};
export type LinkAssetPayload = {
  projectId: string;
  Assets: string[];
};
